module.exports = __webpack_public_path__ + "static/media/study_coordinator_instructions.084b4720.pdf";